module.exports = __webpack_public_path__ + "img/icon1.b1bfe8b1.png";